import { Button, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { DynamicBoxes } from "./DynamicBoxes";
import { BatteryCells } from "./BatteryCells";
import cylindrical from "../../../assets/img/newcellWObg.png";
import prismatic from "../../../assets/img/prismatic.png";
import pouch from "../../../assets/img/newPouch.png";
import circuitImage from "../../../assets/img/portfolio/newCell2.jpg";
import { StyledButton, StyledTypography } from "../styles/styles";

const BatteryConfig = ({
  voltage,
  capacity,
  cellType = "cylindrical",
  cellCondition = "Recycled cell",
  isConfig,
  ageYears,
  ageMonths,
  chemistry,
  format,
  makeModel,
  uploadData,
  setSelectedConfig,
  selectedConfig,
  sohData = false,
  hideBox = false,
}) => {
  const [num_cols, setNum_cols] = useState(9);
  const [num_row, setNum_row] = useState(2);
  const [div_html, setDivHtml] = useState([]);
  const [packVoltage, setPackVoltage] = useState(33.3);
  const [packCapacity, setPackCapacity] = useState(10);
  const [packWeight, setPackWeight] = useState(1.3);
  const [totalCells, setTotalCells] = useState(18);
  const [packPrice, setPackPrice] = useState(108);
  const [cellImage, setCellImage] = useState(cylindrical);



  // useEffect(() => {
  //   if (isConfig) {
  //     BatteryProcure();
  //   }
  // }, [isConfig]);

  const batteryConfig = () => {
    const wt = 72;
    const default_cell_capacity = selectedConfig.cellCapacity;
    const num_row = Math.ceil(capacity / default_cell_capacity);
    const num_cols = Math.ceil(voltage / (selectedConfig.cellVoltage));
    const total_cap = default_cell_capacity * num_row;
    const total_wt = (wt * num_cols * num_row) / 1000;
    const total_cells = num_row * num_cols;
    setTotalCells(total_cells);
    setNum_cols(num_cols);
    setNum_row(num_row);
    setPackVoltage(Math.round(num_cols * selectedConfig.cellVoltage * 100) / 100);
    setPackCapacity(Math.round(total_cap * 100) / 100);
    setPackWeight(Math.round(total_wt * 100) / 100);
    let tempDivs = [];
    for (let i = 0; i < total_cells; i++) {
      tempDivs.push(
        <div className="mybox" key={i}>
          <img src={cellImage} style={{ width: "100%", backgroundColor: "black" }} alt="Cell" />
        </div>
      );
    }
    setCellImage(circuitImage);
    setDivHtml(tempDivs);
  };

  const BatteryProcure = () => {
    if (cellType === "prismatic") setCellImage(prismatic);
    else if (cellType === "cylindrical") setCellImage(cylindrical);
    else setCellImage(pouch);
    
    const wt = 72;
    const pricePerCellOld = 3;
    const pricePerCellNew = 6;
    const default_cell_capacity = selectedConfig.cellCapacity;
    const num_row = Math.ceil(capacity / default_cell_capacity);
    const num_cols = Math.ceil(voltage / selectedConfig.cellVoltage);
    const total_cap = default_cell_capacity * num_row;
    const total_cells = num_row * num_cols;
    const total_wt = (wt * num_cols * num_row) / 1000;
    setTotalCells(Math.round(num_cols * num_row));
    setPackVoltage(Math.round(num_cols * selectedConfig.cellVoltage * 100) / 100);
    setPackCapacity(Math.round(total_cap * 100) / 100);
    setPackWeight(Math.round(total_wt * 100) / 100);
    setNum_cols(num_cols);
    setNum_row(num_row);
    if (cellCondition === "Recycled cell") {
      setPackPrice(total_cells * pricePerCellOld);
    } else {
      setPackPrice(total_cells * pricePerCellNew);
    }
  };


  useEffect(() => {
    if (selectedConfig) {
      setSelectedConfig({
        ...selectedConfig,
        num_cols: num_cols,
        totalCells: totalCells,
      });
    }
  }
  , [num_cols, totalCells]);

  useEffect(() => {
    if (isConfig) {
      batteryConfig();
    } else{
      BatteryProcure();
    }
  }, [voltage, capacity, cellType, cellCondition, isConfig]);

  return (
    <>
    <div className="flex flex-col justify-center items-center text-center gap-8 w-full">
        <BatteryCells
          num_cols={num_cols}
          div_html={div_html}
          isConfig={isConfig}
          cellImage={cellImage}
          totalCells={totalCells}
          sohData={sohData}
          cellVoltage={selectedConfig.cellVoltage}
        />

      {!hideBox && (
      <DynamicBoxes
        packVoltage={packVoltage}
        packCapacity={packCapacity}
        packWeight={packWeight}
        totalCells={totalCells}
        packPrice={packPrice}
        isConfig={isConfig}
        cellVoltage={selectedConfig.cellVoltage}
        cellCapacity={selectedConfig.cellCapacity}
        num_cols={num_cols}
        num_row={num_row}
      />
      )}
    </div>
    </>
  );
};

export default BatteryConfig;
